import { ORG_ADMIN } from 'common/constants/general';

export const getOrgs = (state) => state.org?.orgs;
export const getCurrentOrgMembers = (state) => state.org?.orgMembers;
export const getCurrentOrgAdmins = (state) => state.org?.orgAdmins;
export const getCurrentOrg = (state) => state.org?.org;
export const isOrgLoading = (state) => state.org?.loading;
export const isAdmin = (state) => isOrgAdmin(state) || state.user?.userData?.viewer?.isSuperUser;
export const isOrgAdmin = (state) => state.org?.orgUserInfo?.type === ORG_ADMIN;
